<template>
<div class="jointenants">
  <div class="tit">{{name}}送您200元专属礼包啦</div>
  <!-- <img src="@/assets/images/friend03.png" class="topimg"/> -->
  <img src="@/assets/images/friend01.png" class="logo"/>
  <img src="@/assets/images/friend02.png" class="parter">
  <h2>大方租车是全国首家0押金共享租车</h2>
  <div>芝麻分550分及以上通过支付宝下单有机会享受租车押金和违章押金全免</div>
  <button class="gorent" @click="gorent()">立即领取</button>
 
</div>
</template>
<script>
import { orderSource } from "@/utils/env";
export default {
  name: "jointenants",
  data() {
    return {
     userID:'',
     name:'',
     schemeUrl:'dafangzuche://',
     appurl:'',
     orderSource:orderSource,
     Android:false,
     weixin:false
    };
  },
  props: [],
  created(){
    this.name = this.$route.query.name;
    this.userID=this.$route.query.userID;
    return
    if(/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)){
      this.ios=true
    }else if(/(Android)/i.test(navigator.userAgent)){
      this.Android = true
    }else if(/MicroMessenger/i){
      this.weixin = true
    }
    console.log(this.$route.query)
  },
  methods: {
    gorent(){
      window.location.href = 'http://m.dafang24.com/normalLogin?inviteType=4&userID='+this.userID;
      return
      let IOSUrlDownload = 'https://itunes.apple.com/app/apple-store/id=xxxxxxx?ct=web&mt=8';
      let AndroidUrlDownload = 'http://a.app.qq.com/o/simple.jsp?****';
      if(this.ios){
        let loadDateTime=new Date();
        window.setTimeout(function(){
          let timeOutDateTime=new Date();
          if(timeOutDateTime-loadDateTime<5000){
            window.location.href = IOSUrlDownload
          }else{
            alert('对不起，暂时无法打开')
          }
        },1000)
        window.location.href = this.schemeUrl

      }else if(this.Android){
        let loadDateTime=new Date()
        window.location.href=this.schemeUrl
        window.setTimeout(function(){
          let timeOutDateTime=new Date()
          if(timeOutDateTime-loadDateTime<5000){
            window.location.href = AndroidUrlDownload
          }
        },1500)
      }else if(this.weixin){
        window.wx.ready(function(){
          window.location.href=this.schemeUrl
        })
      }

    }
  }
};
</script>

<style lang="scss" scoped type="text/scss">
.jointenants {
  position: absolute;
  top:0px;
  width:100%;
  background: url('~@/assets/images/friend03.png') no-repeat 0 -55px;
  background-size: contain;
  background-color:#fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  .tit{
    position: absolute;
    text-align: center;
    top:102px;
    font-size: 26px;
    color:#fff;
  }
  .topimg{
    width:100%;
   
  }
  .logo{
    width:401px;
    padding-top:532px;
  }
  .parter{
    margin-top:30px;
    width:580px;
  }
  h2{
    font-size: 34px;
    color:#000;
    line-height: 50px;
    font-weight: bold;
    padding-top:30px;
    padding-bottom:19px;
  }
  div{
    width:540px;
    font-size: 26px;
    color:#000;
    line-height: 37px;
  }
  button.gorent{
    font-size: 32px;
    width:600px;
    height: 90px;
    line-height: 90px;
    text-align: center;
    background:#FF8307;
    color:#fff;
    margin:133px 0 92px 0;
    border-radius:45px;
    border:none;
    outline: none;
  }

}
</style>

